import React, { useEffect, useMemo, useState } from "react";
import { addrouteAndRateAPI } from "../../api/api";
import { token, type, userid } from "./AdminAuth";
import { numberOnly } from "../Utils/Helper";

const IP_ROUTE = "IPRoute";

function EnableIpRoutePopup(props) {
  const [countryCode, setCountryCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  // Clear the form whenever the modal is closed.
  useEffect(() => {
    const $modal = window.$ && window.$("#enableIpRouteModal");
    if (!$modal) return undefined;
    const reset = () => {
      setCountryCode("");
      setIsLoading(false);
      seterror({ errarStatus: false, errorMessage: "", bgcolor: "" });
    };
    $modal.on("hidden.bs.modal", reset);
    return () => $modal.off("hidden.bs.modal", reset);
  }, []);

  // Unique countries from the user's current rate list.
  const countries = useMemo(() => {
    const seen = {};
    const out = [];
    (props.rateList || []).forEach((item) => {
      const code = numberOnly(item.regex);
      if (!code || seen[code]) return;
      seen[code] = true;
      out.push({
        country_code: code,
        country_name: item.country_name || code,
      });
    });
    return out.sort((a, b) => a.country_name.localeCompare(b.country_name));
  }, [props.rateList]);

  const enableIpRoute = () => {
    const selected = countries.find((c) => c.country_code === countryCode);
    if (!selected) {
      seterror({
        errarStatus: true,
        errorMessage: "Please select a country",
        bgcolor: "alert alert-danger",
      });
      return;
    }
    setIsLoading(true);
    addrouteAndRateAPI({
      country_code: selected.country_code,
      route: IP_ROUTE,
      status: "1",
      method: "add_iproute",
      system_id: props.selectedSystemID,
      allow_route: props.allow_route,
      user_id: userid,
      token: token,
      type: type,
    }).then((res) => {
      if (res.data.success === true) {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-success",
        });
        setTimeout(() => {
          window.location.href = `/admin/user/rate-route-list/${props.selectedSystemID}`;
        }, 1000);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
        setIsLoading(false);
      }
    });
  };

  return (
    <div
      className="modal fade"
      id="enableIpRouteModal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Enable IP Route for{" "}
              <span className="text-success">{props.selectedSystemID} </span>
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body row">
            <div className="col-md-12">
              {error.errarStatus ? (
                <div className={error.bgcolor} role="alert">
                  <strong>Alert!</strong> {error.errorMessage}
                </div>
              ) : null}
            </div>

            <div className="form-group col-md-6">
              <select className="form-select" value={IP_ROUTE} disabled>
                <option value={IP_ROUTE}>{IP_ROUTE}</option>
              </select>
            </div>

            <div className="form-group col-md-6">
              <select
                className="form-select"
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
              >
                <option value="">Select Country</option>
                {countries.map((c) => (
                  <option key={c.country_code} value={c.country_code}>
                    {c.country_name} ( {c.country_code})
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              onClick={enableIpRoute}
              type="button"
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? "Loading....." : "Add"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EnableIpRoutePopup;
